/**
 * One 24px, single-line, currentColor glyph per ui_category.
 * The SHAPE identifies the category (colour is set by iconStyle elsewhere).
 * Returned as raw inner SVG so the same path works in DOM markers, the panel
 * list, and the drawer header.
 */

const GLYPHS = {
  // Road closure — barrier / no-entry bar
  road_closure: `<circle cx="12" cy="12" r="9"/><line x1="6" y1="12" x2="18" y2="12"/>`,
  // Road disruption — cone / caution
  road_congestion: `<path d="M12 4 L18 20 H6 Z"/><line x1="8.5" y1="12" x2="15.5" y2="12"/>`,
  // Weather — cloud with rain
  weather_alerts: `<path d="M7 15 a4 4 0 0 1 0.5 -7.9 a5 5 0 0 1 9.5 1.4 a3.5 3.5 0 0 1 -1 6.5 H7 Z"/><line x1="9" y1="18" x2="8" y2="20.5"/><line x1="13" y1="18" x2="12" y2="20.5"/>`,
  // Civil disruption — people / group
  civil_disruption: `<circle cx="9" cy="8" r="2.2"/><circle cx="15.5" cy="9" r="1.8"/><path d="M5 18 v-1 a4 4 0 0 1 8 0 v1"/><path d="M13.5 18 v-0.8 a3.2 3.2 0 0 1 5.5 -2"/>`,
  // Political / VIP — flag
  political_disturbance: `<line x1="7" y1="3" x2="7" y2="21"/><path d="M7 4 H18 l-3 3.5 L18 11 H7 Z"/>`,
  // Religious / cultural — temple / gathering
  religious_cultural: `<path d="M12 3 L19 8 H5 Z"/><line x1="6" y1="8" x2="6" y2="20"/><line x1="18" y1="8" x2="18" y2="20"/><line x1="12" y1="11" x2="12" y2="20"/><line x1="4" y1="20" x2="20" y2="20"/>`,
  // Hazard / utility — warning triangle with bang
  hazard: `<path d="M12 4 L21 19 H3 Z"/><line x1="12" y1="10" x2="12" y2="14"/><circle cx="12" cy="16.5" r="0.6"/>`,
};

/** Returns a complete inline SVG string for a category at the given pixel size. */
export function glyphSvg(uiCategory, size = 24, color = "currentColor") {
  const inner = GLYPHS[uiCategory] || GLYPHS.hazard;
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none"
    stroke="${color}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

export default GLYPHS;
